import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
export interface ConfirmModel {
  // title: string;
  // message: string;
}

@Component({
  selector: 'app-confirmdelete',
  templateUrl: './confirmdelete.component.html',
  styleUrls: ['./confirmdelete.component.css']
})
export class ConfirmdeleteComponent implements ConfirmModel {
  public event: EventEmitter<boolean> = new EventEmitter();
  // title: string;
  // message: string;
  constructor(public bsModalRef: BsModalRef) {
  }

  confirm() {
    this.event.emit(true)
    this.closeModal();
  }

  closeModal() {
    this.bsModalRef.hide();
    // this.close();
  }
}
